<script setup>
  import { onBeforeMount, ref } from 'vue'

  import { ManagementApi } from '@/features/api/services/managementApi.js'
  import { useLoadImage } from '@/features/ui/components/forms/utils/useLoadImage.js'

  const props = defineProps({
    clubId: {
      type: String,
      required: true,
    },
    defaultLogo: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'tenantLogo',
      validator: value => {
        return ['tenantLogo', 'appLogo'].includes(value)
      },
    },
  })

  const { loadImage } = useLoadImage()

  const logo = ref()
  const isLoading = ref(true)

  async function logoGet() {
    if (!props.clubId) {
      console.warn('Club ID is required to fetch the logo.')
      isLoading.value = false
      return
    }

    try {
      function downloadAppLogo(signal) {
        return ManagementApi.tenantRegAppLogoDownloadImage(props.clubId, signal)
      }

      if (props.type === 'appLogo') {
        const blobAppLogo = await loadImage({
          action: downloadAppLogo,
        })

        if (blobAppLogo) {
          logo.value = blobAppLogo
          return
        }
      }

      function downloadClubLogo(signal) {
        return ManagementApi.tenantRegLogoDownloadImage(props.clubId, signal)
      }

      const blobLogo = await loadImage({
        action: downloadClubLogo,
      })

      if (blobLogo) {
        logo.value = blobLogo
      }
    } catch (error) {
      console.error('Error while fetching logo', error)
    } finally {
      isLoading.value = false
    }
  }

  onBeforeMount(async () => {
    if (!props.clubId) {
      return
    }

    await logoGet()
  })
</script>

<template>
  <img v-if="!isLoading && logo" :src="logo" class="club-logo-by-id" alt="club logo" />
  <img v-else-if="defaultLogo" :src="defaultLogo" class="club-logo-by-id" alt="club logo" />
</template>

<style lang="scss" scoped>
  .club-logo-by-id {
    object-fit: contain;
  }
</style>
